export interface SupportAttachment {
  id?: string;
  fileUrl: string;
  fileName?: string;
  contentType?: string;
  sizeBytes?: number;
}

export interface SupportAttachmentInput {
  fileUrl: string;
  fileName?: string;
  contentType?: string;
  sizeBytes?: number;
}

export interface SupportTicket {
  id: string;
  subject: string;
  message: string;
  status: string;
  companyId?: string;
  createdByUserId: string;
  createdByDisplayName?: string;
  createdByRole: string;
  visibility: string;
  escalatedAt?: string;
  createdAt: string;
  updatedAt: string;
  attachments?: SupportAttachment[];
  canEscalate?: boolean;
  canChangeStatus?: boolean;
}

export interface SupportComment {
  id: string;
  ticketId: string;
  body: string;
  createdByUserId: string;
  createdByDisplayName?: string;
  createdAt: string;
  isOwnComment: boolean;
  attachments?: SupportAttachment[];
}

export const SUPPORT_TICKET_STATUSES = [
  { value: "open", label: "Open" },
  { value: "in_progress", label: "In Progress" },
  { value: "resolved", label: "Resolved" },
  { value: "closed", label: "Closed" },
] as const;

export function formatTicketStatus(status: string): string {
  const found = SUPPORT_TICKET_STATUSES.find((s) => s.value === status);
  if (found) return found.label;
  return status.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
